// src/components/Layout.js
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const Layout = ({ userName, deviceName, isAuth }) => {
    return (
        <Box sx={{
            maxWidth: 640, mx: 'auto', mt: 1,
            minHeight: '100vh', display: 'flex', flexDirection: 'column',
        }}>
            <Header userName={userName} deviceName={deviceName} isAuth={isAuth} />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    px: {
                        xs: 2,
                        sm: 4,
                    },
                    py: 3,
                    mb: 5,
                }}>
                <Outlet component="main" />
            </Box>
            <Box
                component="footer"
                sx={{
                    px: {
                        xs: 2,
                        sm: 4,
                    },
                    pt: 3,
                    pb: 4,
                }}>
                <Footer />
            </Box>
        </Box>
    );
};

export default Layout;
